import type { BoardConfig, CreateBoardBody, UpdateBoardBody } from '@tasks/contracts';

import { apiRequest, apiRequestList, apiRequestResource, apiRequestVoid } from './client';

/** Доски проекта (docs/05 §7). Чтение — участнику, изменение — админу проекта. */
export function listBoards(key: string, signal?: AbortSignal): Promise<BoardConfig[]> {
  return apiRequestList<BoardConfig>(`/projects/${encodeURIComponent(key)}/boards`, { signal });
}

/** Создание отдаёт `{ board }` — огибающая ресурса (docs/05 §1). */
export function createBoard(key: string, body: CreateBoardBody): Promise<BoardConfig> {
  return apiRequestResource<BoardConfig>(`/projects/${encodeURIComponent(key)}/boards`, 'board', {
    method: 'POST',
    body,
  });
}

/**
 * Изменение доски. `UpdateBoardBody` допускает любое подмножество полей:
 * переименование, набор отображаемых компонентов или оба сразу (docs/05 §7).
 */
export function updateBoard(key: string, boardId: string, body: UpdateBoardBody): Promise<BoardConfig> {
  return apiRequest<BoardConfig>(
    `/projects/${encodeURIComponent(key)}/boards/${encodeURIComponent(boardId)}`,
    { method: 'PATCH', body },
  );
}

/** Совместимость с прежним именем: переименование — частный случай изменения. */
export function renameBoard(key: string, boardId: string, body: UpdateBoardBody): Promise<BoardConfig> {
  return updateBoard(key, boardId, body);
}

export function setDefaultBoard(key: string, boardId: string): Promise<BoardConfig> {
  return apiRequest<BoardConfig>(
    `/projects/${encodeURIComponent(key)}/boards/${encodeURIComponent(boardId)}/default`,
    { method: 'POST' },
  );
}

export function deleteBoard(key: string, boardId: string): Promise<void> {
  return apiRequestVoid(
    `/projects/${encodeURIComponent(key)}/boards/${encodeURIComponent(boardId)}`,
    { method: 'DELETE' },
  );
}